(() => {
  if (window.__fourPixelsBwUiStabilityV5) return;
  window.__fourPixelsBwUiStabilityV5 = true;

  const important = (el, prop, value) => el && el.style.setProperty(prop, value, 'important');
  const queued = new Set();

  const runFrame = (name, fn) => {
    if (queued.has(name)) return;
    queued.add(name);
    requestAnimationFrame(() => {
      queued.delete(name);
      fn();
    });
  };

  const disconnectLegacyWishlistEnhancers = () => {
    Object.keys(window).forEach((key) => {
      if (!/^__fpWishlist(?:StableV7|CompactV6)_/.test(key)) return;
      try {
        const instance = window[key];
        if (instance && typeof instance.disconnect === 'function') instance.disconnect();
      } catch (_) {}
    });
  };

  const ensureSearchMarker = (element, text, key) => {
    if (!element || element.querySelector(`[data-fp-search-marker="${key}"]`)) return;
    const marker = document.createElement('span');
    marker.className = 'visually-hidden';
    marker.dataset.fpSearchMarker = key;
    marker.textContent = ` ${text} `;
    element.appendChild(marker);
  };

  const stabilizeWishlistCard = (card) => {
    if (!card) return;

    const media = card.querySelector('.clozs-wishlist-card__media');
    const body = card.querySelector('.clozs-wishlist-card__body');
    const actions = card.querySelector('.clozs-wishlist-card__actions');
    const image = card.querySelector('.clozs-wishlist-card__image, .clozs-wishlist-card__media img, img');
    const isSmallPhone = window.matchMedia('(max-width: 390px)').matches;
    const mediaWidth = isSmallPhone ? '96px' : '112px';
    const mediaHeight = isSmallPhone ? '128px' : '148px';

    important(card, 'display', 'flex');
    important(card, 'flex-direction', 'row');
    important(card, 'align-items', 'flex-start');
    important(card, 'align-self', 'start');
    important(card, 'width', '100%');
    important(card, 'height', 'auto');
    important(card, 'min-height', '0');
    important(card, 'max-height', 'none');
    important(card, 'overflow', 'hidden');
    important(card, 'direction', 'ltr');

    if (media) {
      important(media, 'display', 'block');
      important(media, 'flex', `0 0 ${mediaWidth}`);
      important(media, 'width', mediaWidth);
      important(media, 'height', mediaHeight);
      important(media, 'min-width', mediaWidth);
      important(media, 'min-height', '0');
      important(media, 'max-height', mediaHeight);
      important(media, 'align-self', 'flex-start');
      important(media, 'margin', '0');
      important(media, 'overflow', 'hidden');
    }

    if (image) {
      important(image, 'display', 'block');
      important(image, 'width', '100%');
      important(image, 'height', '100%');
      important(image, 'min-height', '0');
      important(image, 'max-height', 'none');
      important(image, 'object-fit', 'cover');
      important(image, 'object-position', 'center');
      important(image, 'margin', '0');
    }

    if (body) {
      important(body, 'display', 'flex');
      important(body, 'flex-direction', 'column');
      important(body, 'flex', '1 1 0');
      important(body, 'width', 'auto');
      important(body, 'min-width', '0');
      important(body, 'height', 'auto');
      important(body, 'min-height', '0');
      important(body, 'max-height', 'none');
      important(body, 'align-self', 'stretch');
      important(body, 'direction', 'rtl');
      important(body, 'text-align', 'right');
      important(body, 'margin', '0');
    }

    if (actions) {
      important(actions, 'margin-top', '12px');
      important(actions, 'margin-bottom', '0');
      important(actions, 'align-self', 'stretch');
    }
  };

  const repairWishlistCard = (card) => {
    if (!card) return;

    const media = card.querySelector('.clozs-wishlist-card__media');
    const body = card.querySelector('.clozs-wishlist-card__body');
    const view = card.querySelector('.clozs-wishlist-card__view');
    const remove = card.querySelector('.clozs-wishlist-card__remove');

    ensureSearchMarker(view, 'view product', 'view');
    ensureSearchMarker(remove, 'remove', 'remove');

    if (card.dataset.fpNativeWishlist !== '1') {
      if (media && media.parentElement !== card) card.insertBefore(media, card.firstChild);
      if (body && body.parentElement !== card) card.appendChild(body);

      card.querySelectorAll('.aligan-wishlist-content').forEach((wrapper) => {
        if (wrapper === body || wrapper.contains(body)) return;
        if (!wrapper.children.length && !wrapper.textContent.trim()) wrapper.remove();
      });

      card.classList.add('aligan-wishlist-card');
      media?.classList.add('aligan-wishlist-media');
      body?.classList.add('aligan-wishlist-content');
      card.dataset.fpNativeWishlist = '1';
    }

    stabilizeWishlistCard(card);
  };

  const normalizeWishlist = () => {
    disconnectLegacyWishlistEnhancers();
    const drawer = document.getElementById('clozs-wishlist-drawer');
    if (!drawer) return;

    /* Mobile shell: replace the thick grey frame with solid black. */
    if (window.matchMedia('(max-width: 560px)').matches) {
      important(drawer, 'border-color', '#000000');
      important(drawer, 'outline-color', '#000000');
      important(drawer, 'box-shadow', '0 12px 34px rgba(0,0,0,.28)');
    }

    const list = drawer.querySelector('.clozs-wishlist-list');
    if (list) {
      important(list, 'display', 'grid');
      important(list, 'grid-template-columns', 'minmax(0,1fr)');
      important(list, 'grid-auto-rows', 'max-content');
      important(list, 'align-content', 'start');
      important(list, 'align-items', 'start');
      important(list, 'height', 'auto');
      important(list, 'min-height', '0');
    }

    drawer.querySelectorAll('.clozs-wishlist-card').forEach(repairWishlistCard);
  };

  const forceFloatingSocialBrandColors = () => {
    const paint = (selector, background, border, color = '#ffffff') => {
      document.querySelectorAll(selector).forEach((el) => {
        important(el, 'background', background);
        important(el, 'background-color', background.startsWith('linear-gradient') ? 'transparent' : background);
        important(el, 'border-color', border);
        important(el, 'color', color);
        el.style.removeProperty('filter');
        el.querySelectorAll('svg, img').forEach((node) => node.style.removeProperty('filter'));
      });
    };

    paint('.fp-sf__toggle', '#000000', '#000000');
    paint('.fp-sf__whatsapp', '#25D366', '#25D366');
    paint('.fp-sf__tiktok', '#000000', '#000000');
    paint('.fp-sf__instagram', 'linear-gradient(135deg,#833ab4 0%,#fd1d1d 55%,#fcb045 100%)', 'transparent');
  };

  const forceFooterMonochrome = () => {
    document.querySelectorAll('.footer').forEach((footer) => {
      const root = footer.closest('.shopify-section') || footer;
      const surfaces = [
        root,
        footer,
        ...footer.querySelectorAll(
          '.footer__content-top, .footer__content-bottom, .footer__blocks-wrapper, .footer__content-top .page-width, .footer__content-bottom .page-width'
        )
      ];

      surfaces.forEach((el) => {
        important(el, 'background', '#000000');
        important(el, 'background-color', '#000000');
        important(el, 'color', '#ffffff');
      });

      footer.querySelectorAll(
        'a, p, span, li, h1, h2, h3, h4, h5, h6, .footer-block__heading, .list-menu__item--link, .copyright__content, .footer__copyright'
      ).forEach((el) => {
        if (el.closest('.list-payment, .footer__payment')) return;
        important(el, 'color', '#ffffff');
        important(el, 'text-decoration-color', '#ffffff');
      });

      footer.querySelectorAll('.footer__list-social .list-social__link, .list-social__link').forEach((el) => {
        important(el, 'background', '#ffffff');
        important(el, 'background-color', '#ffffff');
        important(el, 'border-color', 'rgba(255,255,255,.8)');
        important(el, 'color', '#000000');
      });

      footer.querySelectorAll('.list-payment, .list-payment__item, .footer__payment').forEach((el) => {
        important(el, 'background', 'transparent');
        important(el, 'background-color', 'transparent');
      });
      footer.querySelectorAll('.list-payment svg, .list-payment img, .footer__payment svg, .footer__payment img').forEach((el) => {
        el.style.removeProperty('filter');
        el.style.removeProperty('fill');
        el.style.removeProperty('color');
        el.style.removeProperty('background');
        el.style.removeProperty('background-color');
      });

      footer.querySelectorAll('.footer__content-bottom, .footer__content-bottom-wrapper').forEach((el) => {
        important(el, 'border-color', 'rgba(255,255,255,.16)');
      });
    });
  };

  const forceFiltersMonochrome = () => {
    document.querySelectorAll('.mobile-facets, .mobile-facets__inner, .mobile-facets__header, .mobile-facets__main, .mobile-facets__submenu, .mobile-facets__footer, .facets__display, .facets__inner, .facets__main, .facets__footer').forEach((el) => {
      important(el, 'background', '#ffffff');
      important(el, 'background-color', '#ffffff');
      important(el, 'color', '#000000');
    });
    document.querySelectorAll('.mobile-facets__footer .button, .facets__footer .button, .facets__open.button, .mobile-facets__open.button').forEach((el) => {
      important(el, 'background', '#000000');
      important(el, 'background-color', '#000000');
      important(el, 'border-color', '#000000');
      important(el, 'color', '#ffffff');
    });
  };

  const forceCollectionsWhite = () => {
    document.querySelectorAll('.collection-list').forEach((list) => {
      const section = list.closest('.shopify-section');
      if (section) {
        important(section, 'background', '#ffffff');
        important(section, 'background-color', '#ffffff');
      }
    });
  };

  const hideReviewApps = () => {
    const isProduct = document.body?.classList.contains('template-product') || /\/products\//.test(location.pathname);
    if (!isProduct) return;
    const selectors = [
      '.jdgm-preview-badge','.jdgm-widget','[class*="jdgm-preview"]','[id*="jdgm-preview"]','[class*="judgeme"]','[id*="judgeme"]',
      '[class*="doran"][class*="review"]','[class*="doran"][class*="rating"]','[class*="doran"][class*="star"]','[id*="doran"][id*="review"]','[id*="doran"][id*="rating"]',
      '[class*="trustoo"][class*="review"]','[class*="trustoo"][class*="rating"]','[class*="trustoo"][class*="star"]','[id*="trustoo"][id*="review"]','[id*="trustoo"][id*="rating"]','[class*="cwilltrustoo"]','[id*="cwilltrustoo"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      el.hidden = true;
      important(el, 'display', 'none');
      el.setAttribute('aria-hidden', 'true');
    });
  };

  const stabilizeStatic = () => {
    normalizeWishlist();
    forceFloatingSocialBrandColors();
    forceFooterMonochrome();
    forceFiltersMonochrome();
    forceCollectionsWhite();
    hideReviewApps();
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-wishlist-open], [data-wishlist-toggle]')) {
      runFrame('wishlist', normalizeWishlist);
      return;
    }
    if (event.target.closest('.mobile-facets__open, .facets__open')) {
      runFrame('filters', forceFiltersMonochrome);
    }
  }, true);

  document.addEventListener('wishlist:updated', () => runFrame('wishlist', normalizeWishlist));
  document.addEventListener('wishlist:rendered', () => runFrame('wishlist', normalizeWishlist));
  document.addEventListener('wishlist:hydrated', () => runFrame('wishlist', normalizeWishlist));
  document.addEventListener('shopify:section:load', () => runFrame('static', stabilizeStatic));
  window.addEventListener('pageshow', () => runFrame('static', stabilizeStatic));
  window.addEventListener('resize', () => runFrame('wishlist', normalizeWishlist), { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => runFrame('static', stabilizeStatic), { once: true });
  } else {
    runFrame('static', stabilizeStatic);
  }

  /* No document-wide MutationObserver: it was causing repeated full-site passes. */
})();
